import { Event, ProfileImageResponse } from "JS/Models/Events";
import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";

export enum TicketError {
    NoEvents,
    NoneRegistered,
}

interface EventsApiResponse {
    events: Event[];
}

export class TicketsService extends BaseService {
    async getEvents(): Promise<Event[]> {
        try {
            const response = await this.ngCall<EventsApiResponse>(
                "get",
                appConstants.ngEndpoints.events(config.user.memberId),
            );

            const events = response.data?.events || [];

            if (events.length === 0) {
                throw TicketError.NoEvents;
            }

            return events;
        } catch (err) {
            if (err === TicketError.NoEvents) throw err;
            throw TicketError.NoEvents;
        }
    }

    async getEventByName(eventFolderName: string): Promise<Event[]> {
        try {
            const allEvents = await this.getEvents();

            const matched = allEvents.filter(
                (event) =>
                    event.EventName?.replace(/\s+/g, "") === eventFolderName ||
                    event.EventName === eventFolderName,
            );

            if (matched.length === 0) {
                throw "No tickets found";
            }

            return matched;
        } catch (err) {
            throw err;
        }
    }

    getS3PostFileUrl = (fileName: string, isPrimaryUser: number) =>
        this.ngCall<string>(
            "get",
            appConstants.ngEndpoints.pictureUrl(config.user.memberId),
            {
                headers: {
                    Authorization: `Bearer ${config?.ngAccesstoken}`,
                },
                params: {
                    isPrimaryUser,
                },
            },
        );

    async setProfilePhotoInS3(
        file: File | Blob,
        url: string,
    ): Promise<Response> {
        const response = await fetch(url, {
            method: "PUT",
            body: file,
            headers: {
                "Content-Type": file.type,
            },
        });

        if (!response.ok) {
            throw new Error(`S3 upload failed: ${response.statusText}`);
        }

        return response;
    }
    getBarCode(userId: string, isPrimaryUser: number) {
        return this.ngCall<string>(
            "get",
            appConstants.ngEndpoints.getBarCode(userId),
            {
                headers: {
                    Authorization: `Bearer ${config?.ngAccesstoken}`,
                },
                params: {
                    isPrimaryUser,
                },
            },
        );
    }

    async getPdfBlob(url: string): Promise<Blob> {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.statusText}`);
        }
        return await response.blob();
    }

    getProfileImage(userId: string): Promise<ProfileImageResponse> {
        return this.ngCall<ProfileImageResponse>(
            "get",
            appConstants.ngEndpoints.eventProfileImage(userId),
        ).then((response) => response.data);
    }

}
